var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.svgManagerComponent)?_c(_vm.svgManagerComponent,{tag:"component",attrs:{"svg-url":_vm.svgUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }